import styled from 'styled-components';

import { Checkbox } from '@dreryk/react-components';

export const StyledVideoConsultationField = styled(Checkbox)`
   margin-right: auto;
`;
